import React from "react";
import { useRouter } from "next/router";
import { getAuthCredentials, hasAccess, hasPermissions, isUserAllowedTo } from "./auth-utils";
import Loader from "@components/ui/loader/loader";
import AccessDeniedPage from "@components/common/access-denied";
import { ROUTES } from "./routes";
import { siteSettings } from "@settings/site.settings";

const PrivateRoute: React.FC<{ authProps: any }> = ({
  children,
  authProps,
}) => {
  const router = useRouter();
  const { pathname } = router;
  const { token, roles, permissions } = getAuthCredentials();
  const isUser = !!token;
  const hasPermission = !authProps.permissions || hasPermissions(authProps.permissions, permissions, roles);
  const hasRole =
    Array.isArray(roles) &&
    !!roles.length &&
    hasAccess(authProps.roles, roles);
  
  React.useEffect(() => {
    if (!isUser) router.replace(ROUTES.LOGIN); // If not authenticated, force log in
  }, [isUser]);

  if (isUser && (hasRole || hasPermission)) {
    return <>{children}</>;
  }

  if (isUser && (pathname === "" || pathname === ROUTES.DASHBOARD)) {
    // Every top-level entry currently declares permissions, so this behaves as
    // before; the guard is here because the type now admits entries without
    // them, and passing undefined through would be unchecked.
    const firstAllowedRoute = siteSettings.sidebarLinks.admin.find(({ permissions }) =>
      permissions ? isUserAllowedTo(permissions) : false
    );
    if(firstAllowedRoute) {
      router.push(firstAllowedRoute.href);
      return <Loader showText={false} />;
    }
  }
  if (isUser && !hasRole) {
    return <AccessDeniedPage />;
  }
  // Session is being fetched, or no user.
  // If no user, useEffect() will redirect.
  return <Loader showText={false} />;
};

export default PrivateRoute;
